import { DUAL } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';

export function rejectUsedBrokerOptions(options, commissions, transactionSide) {
  const usedUserIds = new Set();
  for (const commission of commissions) {
    if (!commission._destroy && (!transactionSide || [transactionSide, DUAL].includes(commission.transactionSide))) {
      usedUserIds.add(commission.broker?.id);
    }
  }

  return options.filter(option => !usedUserIds.has(option.value));
}

export function brokerLabel(baseLabel, transactionSide, transactionSideOptions) {
  const sideLabel = transactionSideOptions?.find(option => option[0] === transactionSide)?.[1];
  return sideLabel ? `${baseLabel} - ${sideLabel}` : baseLabel;
}

export function internalBrokerLabel(index, transactionSide, transactionSideOptions) {
  return brokerLabel(index === 0 ? 'Primary Broker' : 'Internal Broker', transactionSide, transactionSideOptions);
}

export function isBrokerGrossHidden(commission, forUser, restrictBrokerGrossVisibilityToSelf) {
  return !!restrictBrokerGrossVisibilityToSelf && !forUser.apexAdmin && commission.broker.id !== forUser.id;
}
